<template>
  <!--
search控制搜索栏是否显示
        search传值类型
            true为显示
            fasle为隐藏
-->
  <div class="search" v-if="search"  :style="{height:textheight}">
    <!-- 用户管理  搜索框数据 -->
    <el-form :model="form" v-if="type === 'UserManagement'" label-width="110px" @keyup.enter.native="submit">
      <el-row>
        <el-col :span="7">
          <el-form-item label="用户名称：">
            <el-input clearable v-model="form.account" placeholder="请输入用户名称" style="width:202px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="所属部门：" class="el_main" prop="deptId">
            <el-select
              @change="ChangeSelectFun"
              style="width:100%"
              v-model="form.deptId"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="搜索获取更多部门 "
              :remote-method="departmentRemoteMethod"
              :loading="loading">
              <div style="color:rgb(245 108 108);margin-left:20px;font-size:12px">默认前10条,请搜索关键字
              </div>
              <el-option
                v-for="(item,index) in departmentList"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="用户类型：">
            <el-select v-model="form.userType" style="width:202px" filterable clearable>
              <el-option
                v-for="item in UserTypeEnum"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="14">
        <el-form-item label="社会统一信用代码：">
          <el-input clearable v-model="form.uscCode" style="width:202px"></el-input>
        </el-form-item>
      </el-col>
        <el-col :span="5">
          <el-button type="primary" plain @click="submit()">查询</el-button>
        </el-col>
        <el-col :span="5">
          <el-button type="primary" plain @click="propsfun()" class="FloatRight">新增</el-button>
          <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
        </el-col>
      </el-row>
    </el-form>
    <!-- 部门管理  搜索框数据 -->
    <el-form   :model="form" v-if="type === 'DepartmentManagement'"  label-width="100px" @keyup.enter.native="submit">
      <el-row>
           <el-col :span="6">
            <el-form-item label="部门名称：" class="el_main" prop="deptId">
              <el-input clearable v-model="form.name" placeholder="请输入部门名称" style="width:202px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属部门：" class="el_main" prop="deptId">
              <el-select
                      @change="ChangeSelectFun"
                      style="width:100%"
                      v-model="form.parentId"
                      remote
                      reserve-keyword
                      filterable
                      clearable
                      placeholder="搜索获取更多部门 "
                      :remote-method="departmentRemoteMethod"
                      :loading="loading">
                      <div style="color:rgb(245 108 108);margin-left:20px;font-size:12px">默认前10条,请搜索关键字</div>
                      <el-option
                      v-for="(item,index) in departmentList"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="7">
          <el-form-item label="所属区：" >
              <el-select clearable v-model="form.districtId" placeholder="请输入所属区">
                <el-option  v-for="(item,index) in $Region.list()" :key="index"  :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" plain @click="submit()">查询</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
         <el-col :span="3" >
            <el-button type="primary" plain @click="propsfun()" class="FloatRight">新增</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
      </el-row>
    </el-form>
    <!-- 菜单管理  搜索框数据 -->
    <el-form   :model="form" v-if="type === 'MenuManagement'"  label-width="100px" @keyup.enter.native="submit">
      <el-row>
           <el-col :span="7">
            <el-form-item label="菜单名称：" class="el_main" prop="deptId">
              <el-input clearable v-model="form.name" placeholder="请输入菜单名称" style="width:202px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" plain @click="submit()">查询</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
         <el-col :span="14" >
            <el-button type="primary" plain @click="propsfun()" class="FloatRight">新增</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
      </el-row>
    </el-form>
    <!-- 角色管理  搜索框数据 -->
    <el-form   :model="form" v-if="type === 'RoleManagement'"  label-width="100px" @keyup.enter.native="submit">
      <el-row>
           <el-col :span="7">
            <el-form-item label="角色名称：" class="el_main" prop="deptId">
              <el-input clearable v-model="form.name" placeholder="请输入角色名称" style="width:202px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="子系统：" class="el_main" prop="deptId" label-width="80px">
              <el-select v-model="form.modelId" placeholder="请选择子系统" style="width:100%;" filterable clearable>
                <el-option
                  v-for="item in SubsystemList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <!-- <el-button type="primary" plain @click="propsfun()">新增</el-button> -->
            <el-button type="primary" plain @click="submit()">查询</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
         <el-col :span="8" >
            <el-button type="primary" plain @click="propsfun()" class="FloatRight">新增</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
      </el-row>
    </el-form>
    <!-- 系统管理  搜索框数据 -->
    <el-form   :model="form" v-if="type === 'SystemManagement'"  label-width="100px" @keyup.enter.native="submit">
      <el-row>
          <el-col :span="7">
            <el-form-item label="系统名称：" class="el_main" prop="deptId">
              <el-input clearable v-model="form.name" placeholder="请输入系统名称" style="width:202px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <!-- <el-button type="primary" plain @click="propsfun()">新增</el-button> -->
            <el-button type="primary" plain @click="submit()">查询</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
         <el-col :span="14" >
            <el-button type="primary" plain @click="propsfun()" class="FloatRight">新增</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
         </el-col>
      </el-row>
    </el-form>
    <!-- 权限管理  搜索框数据 -->
    <!-- <el-form   :model="form" v-if="type == 'AuthorityManagement'"  label-width="100px" @keyup.enter.native="submit">
      <el-row>
          <el-col :span="8">
            <el-form-item label="权限名称：" class="el_main" prop="deptId">
              <el-input clearable v-model="form.name" placeholder="请输入权限名称" style="width:202px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-button type="primary" plain @click="propsfun()">新增</el-button>
            <el-button type="primary" plain @click="submit()">查询</el-button>
            <el-button type="primary" plain @click="Export()">导出</el-button>
         </el-col>
      </el-row>
    </el-form> -->
     <!-- 接口管理  搜索框数据 -->
    <el-form   :model="form" v-if="type === 'AuthorityManagement'"  label-width="100px" @keyup.enter.native="submit">
      <el-row>
          <el-col :span="5.5">
            <el-form-item label="接口地址：" class="el_main" prop="deptId">
              <el-input clearable v-model="form.url" placeholder="请输入接口地址" style="width:180px"></el-input>
               <!-- <el-autocomplete
                  class="inline-input"
                  v-model="form.url"
                  style="width:180px"
                  :trigger-on-focus="true"
                  clearable
                  :fetch-suggestions="(queryString,cb) => { $autocomplete.requestData(queryString, cb, this.typeAutocomplete[0].value) }"
                  placeholder="请输入接口地址"
                ></el-autocomplete> -->
            </el-form-item>
          </el-col>
          <el-col :span="5.5">
            <el-form-item label="接口描述：" class="el_main" prop="deptId">
              <el-input clearable v-model="form.description" placeholder="请输入接口地址" style="width:180px"></el-input>
               <!-- <el-autocomplete
                  class="inline-input"
                  v-model="form.description"
                  style="width:180px"
                  :trigger-on-focus="true"
                  clearable
                  :fetch-suggestions="(queryString,cb) => { $autocomplete.requestData(queryString, cb, this.typeAutocomplete[1].value) }"
                  placeholder="请输入接口描述"
                ></el-autocomplete> -->
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="子系统：" class="el_main" prop="deptId" label-width="80px">
              <el-select v-model="form.modelId" placeholder="请选择子系统" style="width:100%;" filterable clearable>
                <el-option
                  v-for="item in SubsystemList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" plain @click="submit()">查询</el-button>
         </el-col>
         <el-col :span="3" class="FloatRight">
            <el-button type="primary" plain @click="Import()">导入</el-button>
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
            <el-button type="primary" plain @click="propsfun()">新增</el-button>
         </el-col>
      </el-row>
    </el-form>
     <!-- 接口管理规则  搜索框数据 -->
    <el-form   :model="form" v-if="type === 'AuthorityManagementRule'"  label-width="100px" @keyup.enter.native="submit">
      <el-row>
          <el-col :span="7">
            <el-form-item label="子系统：" class="el_main" prop="deptId" label-width="80px">
              <el-select v-model="form.modelId" placeholder="请选择子系统" style="width:100%;" filterable clearable>
                <el-option
                  v-for="item in SubsystemList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" plain @click="submit()">查询</el-button>
         </el-col>
         <el-col :span="3" class="FloatRight">
            <!-- <el-button type="primary" plain @click="Export()">导出</el-button> -->
            <el-button type="primary" plain @click="propsfun()">新增</el-button>
         </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    // 搜索栏数据
    search: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    textheight: {
      type: String,
      default: '0'
    },
    datesearch: {
      type: String,
      default: '0'
    },
    typeAutocomplete: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    //  搜索值 有分页
      form: {},
      // 时间
      dateTimess: [],
      Registrationx: [],
      list: [],
      loading: false,
      departmentList: [],
      SubsystemList: [],
      UserTypeEnum: [
        { code: 0, name: '管理员' },
        { code: 1, name: '政府' },
        { code: 2, name: '法人' },
        { code: 3, name: '自然人' }
      ]
    }
  },
  watch: {
    // 'form.unitSourceType':{
    //   handler(n,o){
    //     console.log(n,o)
    //     if(n == 0){
    //       this.areaMunicipal = department.area()
    //     }else{
    //       this.areaMunicipal = department.Municipal()
    //     }
    //     this.disableds = false
    //   },
    //   deep:true
    // },
    dateTimess (v) {
      if (this.type === 'AppealManagement' || this.type === 'AppealAnalysis') {
        this.form.startDate = v ? v[0] : ''
        this.form.endDate = v ? v[1] : ''
      }
    }
  },
  activated () {
    this.$forceUpdate()
  },
  created () {
    this.SubsystemList = this.$Subsystem.list()
    this.departmentRemoteMethod()
  },
  methods: {
    handleSelectChange () {
      this.$forceUpdate()
    },
    // // js暂停的方法
    // sleep (interval) {
    //   return new Promise(resolve => {
    //     this.loading = true
    //     setTimeout(resolve, interval)
    //   })
    // },
    // async Layoutfun (query, data, Parameter1) {
    //   if (query !== undefined) {
    //     await this.sleep(150)
    //     this.loading = false
    //     // eslint-disable-next-line no-eval
    //     return data.filter(item => { return eval('item.' + Parameter1).toLowerCase().indexOf(query.toLowerCase()) > -1 })
    //   } else {
    //     return data.slice(0, 10)
    //   }
    // },
    // 所属部门
    departmentRemoteMethod (query) {
      this.loading = true
      setTimeout(() => {
        this.departmentList = this.$Layoutfun.ProcessingData(query, this.$department.list(), 'name')
        this.loading = false
      }, 300)
    },
    // 下拉框事件改变
    ChangeSelectFun (event) {
      if (!event) {
        this.departmentRemoteMethod(event)
      }
    },
    // 导出
    Export () {
      this.$confirm('确定要导出Excel表格吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        iconClass: 'el-icon-download'
      }).then(() => {
        this.$emit('Export')
      }).catch(() => {})
    },
    // 导入
    Import () {
      // this.$confirm('确定要导入Excel表格吗', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      //   iconClass: 'el-icon-upload2'
      // }).then(() => {
      this.$emit('Import')
      // }).catch(() => {})
    },
    // Putitfun() {
    //   this.Putitif = !this.Putitif;
    //   this.Putitif
    //     ? (this.Putitfuntitle = "收起")
    //     : (this.Putitfuntitle = "展开");
    // },
    // 新增
    propsfun (v) {
      this.$emit('add-data', v)
    },
    // 查询
    submit () {
      this.$emit('search-data', this.form, this.type)
    }
  }
}
</script>

<style lang='scss' scoped>
.Putitaway {
  user-select: none;
  font-size: 15px;
  color: #818181;
  cursor: pointer;
  span:last-child {
    margin-right: 10px;
  }
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 17px;
  vertical-align: top;
}
.search {
  margin: unset !important;
  width: 100%;
}
.searcheight{
  height: 135px;
}
// .el-select {
//   width: 150px;
// }

.el_button {
  float: right;
}
.el_buttons {
  float: left;
}
.el_main {
  float: left;
}
.el-inputs{
  width: 150px;
}
.buttons{
  height: 60px;
}
.FloatRight{
  float: right;
}
</style>
